import { render, staticRenderFns } from "./FileShareCopySetting.vue?vue&type=template&id=f6297d94&scoped=true"
import script from "./FileShareCopySetting.vue?vue&type=script&lang=js"
export * from "./FileShareCopySetting.vue?vue&type=script&lang=js"
import style0 from "./FileShareCopySetting.vue?vue&type=style&index=0&id=f6297d94&prod&lang=scss&scoped=true"
import style1 from "./FileShareCopySetting.vue?vue&type=style&index=1&id=f6297d94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6297d94",
  null
  
)

export default component.exports